import moment from 'moment';
import { IVinculoCpfAdmissao } from '../../models/vinculo-cpf-admissao.model';

export class VinculoCpfModalService {
    static $inject = ['$uibModal', ];

    constructor(
        public $uibModal: any,
    ) { }

    open(cpf: string, vinculo: IVinculoCpfAdmissao): any {
        return this.$uibModal.open({
            template: require('html-loader!./vinculo-cpf.modal.html'),
            controller: [
                '$uibModalInstance',
                function VinculoCpfModal(
                    $uibModalInstance: any,
                ): void {

                    let selfModal = this;
                    const formataData = (data: string | null) => data ? moment(data).format('DD/MM/YYYY') : null;

                    selfModal.cpf = (cpf || '').replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
                    selfModal.detalhes = vinculo.detalhes;
                    selfModal.dataadmissao = formataData(vinculo.detalhes?.dataadmissao);
                    selfModal.datadesligamento = formataData(vinculo.detalhes?.datadesligamento);
                    selfModal.salvaem = formataData(vinculo.detalhes?.created_at);

                    // situação da admissão: -1 salva (não efetuada), 0 enviada, 1 efetuada
                    const cenariosAdmissao: { [situacao: number]: string } = {
                        [-1]: 'admissaoSalva',
                        0: 'admissaoEnviada',
                        1: 'admissaoEfetuada',
                    };
                    selfModal.cenario = vinculo.origem === 'trabalhador'
                        ? 'trabalhador'
                        : cenariosAdmissao[vinculo.situacao];

                    selfModal.close = (): void => {
                        $uibModalInstance.dismiss('fechar');
                    };

                }
            ],
            controllerAs: '$ctrl',
            windowClass: 'modal-vinculo-cpf-admissao',
        });
    }

}
